import { useEffect, useRef, useState } from "react";

export default function AutoScrollText({ children, speed = 8 }) {
  const ref = useRef(null);
  const [overflow, setOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Detecta si el texto es más largo que el contenedor
    setOverflow(el.scrollWidth > el.clientWidth);
  }, [children]);

  return (
    <div
      ref={ref}
      className={`whitespace-nowrap text-white overflow-hidden ${
        overflow ? "auto-scroll" : "truncate"
      }`}
      style={{
        animation: overflow ? `scrollText ${speed}s linear infinite` : "none",
      }}
    >
      {children}
    </div>
  );
}
